/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { isAbsoluteUrl, isRelativeUrl, logDebug, logError } from '../../utils/script-utils';
import { IDefaultInlineStyleProps } from './default-inline-style.props.autogenerated';

/**
 *
 * DefaultStyle
 * @extends {React.PureComponent<IDefaultInlineStyleProps<{}>>}
 */

const DefaultInlineStyle = (props: IDefaultInlineStyleProps<{}>) => {
    const { config, id, typeName, telemetry } = props;
    logDebug(`Adding style tags for '${id}/${typeName}'`, telemetry);
    const source = config.inlineStyle;

    if (!source || source === '' || isAbsoluteUrl(source) || isRelativeUrl(source)) {
        logError('Invalid inline style - Empty inline source defined or a url is being used as a source.', telemetry);
        return null;
    }

    if (source.includes('</style>')) {
        logError('Invalid inline style - inline style should not contain html tags', telemetry);
        return null;
    }

    const styleHtml = `<style>${source}</style>`;
    return React.createElement(SDK_FRAGMENT_NAME, { key: id, dangerouslySetInnerHTML: { __html: styleHtml } });
};

export default DefaultInlineStyle;
